import { axiosService } from '../.';

export default class GetOrganizationBusinessOrderNotViewedCountByBusinessId {
    public async execute(businessId: number): Promise<number> {
        const data = (await axiosService.instance.get(`orders/businesses/organization/not-viewed/${businessId}`)).data;
        return data;
    }
}

export const getOrganizationBusinessOrderNotViewedCountByBusinessId = new GetOrganizationBusinessOrderNotViewedCountByBusinessId();
